const faqs = [
    {
        id: 'faq-1',
        ques: 'What is the scope of the data captured in the Global Growth Cube?',
        ans: `<ul>
<li>The database captures assets that are managed by professional asset managers (i.e. not managed by the investor directly)</li>
<li>The sizing is based on a “client domicile” view </li>
</ul>`
    },
    {
        id: 'faq-2',
        ques: 'What currency is used for market sizing?',
        ans: `<ul>
<li>All markets are sized in their respective local currencies</li>
<li>The data for the full time series is then translated into USD, EUR and GBP using the latest year average FX rate, in order to mitigate the impact of FX rate volatility on the data</li>
</ul>`
    },
    {
        id: 'faq-3',
        ques: 'Can AUM be split between 3rd party and affiliated assets?',
        ans: `<ul>
<li>AUM split for 3rd party vs affiliated is available for the Full Granularity dataset, <strong>for Insurance Companies only</strong></li>
</ul>`
    },
    {
        id: 'faq-4',
        ques: 'How are “Retail/HNW” and “Institutional” segments separated?',
        ans: `<ul>
<li>Assets managed on behalf of individual investors are classified as “Retail/HNW” (incl. unit-linked assets); assets managed on behalf of institutional clients, as “Institutional”</li>
<li>Primary sources for splits are local statistics, e.g.,
<ul>
<li>Germany: BVI (Retail) and Bundesbank (Institutional)</li>
<li>India: Association of Mutual Funds (Retail and Institutional)</li>
</ul>
</li>
</ul>`
    },
    {
        id: 'faq-5',
        ques: 'How are Net Revenues calculated?',
        ans: `<ul>
<li>Net Revenues are calculated using average annual AUM and revenue margins</li>
<li>Revenue margins consist of <strong>management fees</strong> net of retrocessions and exclude performance fees (or carried interest for alternative strategies)</li>
</ul>`
    },
    {
        id: 'faq-6',
        ques: 'How are revenue margins by product derived?',
        ans: `<ul>
<li>Net revenue margins are primarily sourced from McKinsey’s Asset Management Surveys. For strategies or geographies where survey coverage is limited (e.g., private market alternatives in LATAM), the Growth Cube team builds estimates based on representative samples of funds and management fee references from external data sources (e.g., Preqin)</li>
</ul>`
    }
];

export default faqs;
